import { render, staticRenderFns } from "./infoPay.vue?vue&type=template&id=56011dec"
import script from "./infoPay.vue?vue&type=script&lang=js"
export * from "./infoPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports